import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/root/store';

import type { OrgProfile } from '@appTypes/esb';
import {
  Program,
  organizationGuidSel,
  selectedOrganizationSel,
} from '@modules/shared';

/**
 * Returns the current Unit's program. Usage:
 *
 * ```
 * const program = useSelector(programSel);
 * if (program === Program.BOY_SCOUT) console.log("Unit is a Troop!")
 * ```
 */
export const programSel = createSelector(
  selectedOrganizationSel,
  org => org?.program,
);

export const isSeaScoutSel = createSelector(
  programSel,
  program => program === Program.SEA_SCOUT,
);

export const isScoutsBsaUnitSel = createSelector(
  programSel,
  program => program === Program.BOY_SCOUT,
);

export const isVenturingUnitSel = createSelector(
  programSel,
  program => program === Program.VENTURING,
);

export const isCubScoutsUnitSel = createSelector(
  programSel,
  program => program === Program.CUB_SCOUT,
);

export const unitProfilesSel = (state: RootState) =>
  state.unit.unitProfiles as Record<string, OrgProfile>;

export const selectedUnitProfileSel = createSelector(
  organizationGuidSel,
  unitProfilesSel,
  (orgGuid, profiles) => profiles[orgGuid as string],
);
